var React = require('react');

function UserInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"User"),React.createElement("mask",{"id":"a","height":"40","maskUnits":"userSpaceOnUse","width":"40","x":"7","y":"27.6","key":1},React.createElement("path",{"d":"m27-1.4c14.9 0 27 12.1 27 27s-12.1 27-27 27-27-12.1-27-27 12.1-27 27-27z","fill":"#fff","stroke":"#e5e5e5","strokeWidth":"2"})),React.createElement("g",{"mask":"url(#a)","key":2},React.createElement("circle",{"cx":"27","cy":"47.6","fill":"none","r":"19","strokeWidth":"2"})),React.createElement("circle",{"cx":"27","cy":"20.6","fill":"none","r":"8","strokeWidth":"2","key":3})]);
}

UserInline.defaultProps = {"enableBackground":"new 0 0 54 54","viewBox":"0 0 54 54"};

module.exports = UserInline;

UserInline.default = UserInline;
